function isDevelopment() {
  return window.location.href.indexOf("localhost") >= 0;
}

const developmentConfig = {
  url: {
    panel: "http://localhost:3000",
    test: "http://localhost:3002",
    api: "http://api.localhost",
  },
};

const productionConfig = {
  url: {
    panel: `https://eneagrama-painel.institutofabianacarvalho.com.br`,
    test: `https://eneagrama.institutofabianacarvalho.com.br`,
    api: `https://eneagrama-api.institutofabianacarvalho.com.br`,
  },
};

export default isDevelopment() ? developmentConfig : productionConfig;
